import styled from "styled-components";

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${({ theme }) => theme.space[2]};

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    flex-direction: row;
  }
`;

export const LoadingContainer = styled.div`
  padding: ${({ theme }) => theme.space[3]};
  text-align: center;
`;

export const AuthenticatedContainer = styled.div`
  padding: ${({ theme }) => theme.space[3]};
  text-align: center;
`;
